import * as utils from './utils';
import smsConversationIcon from '../assets/images/smsConversationIcon.svg';
import webchatConversationIcon from '../assets/images/webchatConversationIcon.svg';
import webchatConversationClosedIcon from '../assets/images/webchatConversationClosedV2Icon.svg';
import { getCustomerFromSmsChannel } from './contactHelpers';

/**
 * @param {array} messageCollection
 * @param {object} channel
 * @return
 */
export const getLastMessageForChannel = (messageCollection, channel, hiddenMessages) =>
  messageCollection &&
  channel?.LastMessage?._id &&
  !hiddenMessages?.includes(channel.LastMessage._id)
    ? messageCollection.find((f) => f._id === channel.LastMessage._id)
    : null;

/**
 * @param {object} loggedUser
 * @param {object} channel
 * @return
 */
export const getChannelName = (loggedUser, channel) => {
  const contact =
    channel.ChannelType && channel.ChannelType.TypeId === utils.ChannelTypeEnum.SMS.TypeId
      ? getCustomerFromSmsChannel(channel)
      : channel.Contacts.find((f) => f._id !== loggedUser._id && !f.IsDeleted);

  if (channel.ChannelType) {
    if (
      contact &&
      (contact.FirstName?.trim() || contact.LastName?.trim() || contact.CompanyName?.trim())
    ) {
      return contact.getFullName;
    }

    if (contact && contact.CpUsername?.trim()) {
      return `${contact.CpUsername}`;
    }

    if (
      channel.ChannelType.TypeId === utils.ChannelTypeEnum.SMS.TypeId &&
      channel.CustomerPhoneNumber
    ) {
      return `${channel.CustomerPhoneNumber.Number}`;
    }
  }

  return 'Unknown contact';
};

/**
 * @param {object} channel
 * @return
 */
export const getChannelIcon = (channel) => {
  if (channel?.ChannelType) {
    if (channel.ChannelType.TypeId === utils.ChannelTypeEnum.SMS.TypeId) {
      return smsConversationIcon;
    }

    if (channel.ChannelType.TypeId === utils.ChannelTypeEnum.WebChat.TypeId) {
      const isWebChatClosed =
        channel?.ChannelStateType?.TypeId === utils.ChannelStateTypeEnum.Closed.TypeId;
      return isWebChatClosed ? webchatConversationClosedIcon : webchatConversationIcon;
    }
  }

  return smsConversationIcon;
};

/**
 * @param {object} channel
 * @return
 */
export const getChannelTypeLabel = (channel) => {
  if (channel?.ChannelType) {
    if (channel.ChannelType.TypeId === utils.ChannelTypeEnum.SMS.TypeId) {
      return 'TEXT CHAT';
    }

    if (channel.ChannelType.TypeId === utils.ChannelTypeEnum.WebChat.TypeId) {
      return 'WEB CHAT';
    }
  }

  return 'TEXT CHAT';
};
